import React, { useState } from "react";
import home from "../../assets/img/home.png";
import { Link, useNavigate } from "react-router-dom";

function WorksMap() {
  const [selectedTab, setSelectedTab] = useState("works"); // Default tab
  const navigate = useNavigate();

  // 함수를 통해 선택된 탭을 변경하는 로직
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    navigate(`/${tab}`);
  };

  // 함수를 통해 선택된 탭에 따라 타이틀을 동적으로 생성
  const renderTitle = () => {
    switch (selectedTab) {
      case "works":
        return <p>사업 소개</p>;
      case "works2":
        return <p>지역사회 문제 해결</p>;
      case "works3":
        return <p>메이커 스페이스 운영</p>;
      case "works4":
        return <p>창업 지원</p>;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex gap-3 text-sm font-semibold">
        {/* 아이콘 */}
        <Link to="/">
          <img src={home} alt="logo" className="h-4" />
        </Link>
        <p>></p>
        <Link to="/works">
          <p>사업 소개</p>
        </Link>
        <p>></p>
        <p className="text-main">{renderTitle()}</p>
      </div>
      {/* 타이틀 */}
      <p className="text-5xl font-bold text-gray-900">{renderTitle()}</p>
      {/* 상세 */}
      <div>
        <div className="inline-flex items-center h-10 gap-1 px-1 bg-gray-100 rounded-full">
          <button
            onClick={() => handleTabChange("works")}
            className={`h-8 px-6  rounded-full ${
              selectedTab === "works" ? "bg-main text-white" : "text-gray-500"
            }`}
          >
            {" "}
            사업 소개
          </button>
          <button
            onClick={() => handleTabChange("works2")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "works2" ? "bg-main text-white" : "text-gray-500"
            }`}
          >
            {" "}
            지역사회 문제 해결
          </button>
          <button
            onClick={() => handleTabChange("works3")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "works3" ? "bg-main text-white" : "text-gray-500"
            }`}
          >
            {" "}
            메이커 스페이스 운영
          </button>
          <button
            onClick={() => handleTabChange("works4")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "works4" ? "bg-main text-white" : "text-gray-500"
            }`}
          >
            {" "}
            창업 지원
          </button>
        </div>
      </div>
    </div>
  );
}

export default WorksMap;
